import styled from "@emotion/styled/macro";
import { colors } from "../../../../../common/styles/theme.styles";

export const PeriodDropdownContainer = styled.div`
    width: 280px;
    min-height: 372px;
    max-height: 400px;
    background: #fff;
    border: 1px solid ${colors.gray3};
    border-radius: 12px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
    padding: 16px 0px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
`;

export const PeriodDropdownHeader = styled.div`
    font-family: Circular;
    font-size: 12px;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.gray2};
`;

export const PeriodDropdownBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0px;
    flex: 1;
    overflow-y: auto;
    margin-inline: 4px;
`;

export const PeriodYearOption = styled.div`
    height: 36px;
    padding: 6px 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin: 0 8px 4px 8px;
    transition: all 0.2s ease;

    &:hover {
        background: #E8E9EA;
    }
`;

export const PeriodQuarterOption = styled.div`
    height: 32px;
    padding: ${({ isIndented }) => isIndented ? '6px 32px' : '6px 10px'};
    border-radius: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 8px 4px 8px;
    transition: all 0.2s ease;

    &:hover {
        background: #E8E9EA;
    }
`;

export const PeriodOptionContent = styled.div`
    display: flex;
    align-items: center;
`;

export const PeriodExpandIcon = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PeriodSeparator = styled.div`
    height: 0px;
    border-bottom: 1px solid #DDE3EB;
    margin: 8px 0px 4px;
    width: 100%;

    &.search-active {
        margin: 4px 0px;
    }
`;

export const PeriodCheckbox = styled.div`
    position: relative;
    width: 18px;
    height: 18px;

    input {
        opacity: 0;
        position: absolute;
        cursor: pointer;
        width: 100%;
        height: 100%;
        margin: 0;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        width: 18px;
        height: 18px;
        background-color: #fff;
        border: 1.125px solid ${colors.gray3};
        border-radius: 5.4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);

        svg {
            opacity: 0;
            transition: opacity 0.2s ease;
        }
    }

    input:checked ~ .checkmark {
        background-color: ${colors.darkGray1};
        border-color: ${colors.darkGray1};

        svg {
            opacity: 1;
        }
    }

    .checkmark.partial {
        background-color: transparent;
        border: none;
        box-shadow: none;
        
        svg {
            opacity: 1;
            position: absolute;
            top: -2px;
        }
    }

    &:hover .checkmark {
        border-color: ${colors.darkGray1};
    }
`;

export const PeriodLabel = styled.div`
    font-family: Circular;
    font-size: 14px;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.darkGray1};
    flex: 1;
    margin-left: 8px;
`; 